export default __webpack_public_path__ + "static/gh.52549b72ac7c2356cc638a6d89510e20.png";